<template>
    <div>
        <img src="../assets/img/fanhui.png" alt="" class="fanhuiBtn" @click="fanhui">
        <Swiper :swiperImg="swiperImg"></Swiper>
        <div class="jiudianjieshao">
            <p class="logo">
                <img src="../assets/img/Yihao/logo.png" alt="">
            </p>
            <p class="oneImg">
                <video src="../assets/video/yihao.mp4" autoplay="autoplay" muted controls style="width:100%;"></video>
            </p>
            <p class="wenzijieshao">
                “怡豪”山东文旅酒店集团旗下五星级标准高端全服务酒店品牌，始于齐鲁大地，以礼待人、以诚待客、以信待友承齐鲁风华，敬四海之客，用热情真挚、细致入微的态度，将好客山东的精神融入到每次的服务中，让全球旅客感受到如家般的温暖，享受旅程中无与伦比的美妙时刻。怡豪，礼遇之美与文化之韵交汇，用东方文化承载您的每一次非凡旅程。
            </p>
            <p class="manxiang">
                <img src="../assets/img/Yihao/yuan.png" alt="">
                <span>怡豪·怡享非凡</span>
            </p>
            <div class="photoZhanshi">
                <img src="../assets/img/Yihao/wenzi.png" alt="" class="gaoduan">
                <div class="shishangpinzhi">
                    <div>
                        <img src="../assets/img/Yihao/wenzi1.png" alt="">
                    </div>
                    <div>
                        <img src="../assets/img/Yihao/wenzi2.png" alt="">
                    </div>
                </div>
                <img src="../assets/img/Yihao/4.png" alt="" class="shengyu">
                <img src="../assets/img/Yihao/5.png" alt="" class="shengyu">
                <img src="../assets/img/Yihao/6.png" alt="" class="shengyu lastImg">
            </div>
        </div>
        <div class="jiamengyaoqiu">
            <p class="wuyeyaoqiu">物业要求</p>
            <ul class="wuyejuti">
                <li>
                    <span>单房投资</span>
                    <span>22-30万/间</span>
                </li>
                <li>
                    <span>房量</span>
                    <span>200-350间</span>
                </li>
                <li>
                    <span>建筑体量</span>
                    <span>2.5-4万㎡</span>
                </li>
                <li>
                    <span>发展区域</span>
                    <span>繁华地段高品质生活区域</span>
                </li>
                <li>
                    <span>客房净面积</span>
                    <span>35-200㎡</span>
                </li>
                <li>
                    <span>经营功能配套</span>
                    <span>酒店大堂、大堂吧、全日制自助餐厅、风味餐厅、中餐厅(山东文旅鲁菜馆)、会议厅、多功能厅、宴会厅、健身房(含游泳池)、SPA、文创/礼品展卖区、高级/豪华客房层、行政客房层、行政酒廊等</span>
                </li>
            </ul>
            <p class="jiamengzhengce">加盟政策(委托管理)</p>
            <ul class="zhengcejuti">
                <li>
                    <span>加盟期限</span>
                    <span>10年</span>
                </li>
                <li>
                    <span>品牌使用费</span>
                    <span>一次性收取100万元</span>
                </li>
                <li>
                    <span>品牌经营保证金</span>
                    <span>20万</span>
                </li>
                <li class="juda">
                    <span>前期技术支持服务费</span>
                    <span>100万元/年，合同期内管理公司派遣工程、运营人员提供技术咨询服务各六次每次服务时间不超过三天;如需增加现场咨询频次,每次加收5000元费用</span>
                </li>
                <li class="juda">
                    <span>基本管理费</span>
                    <span>据酒店面积按酒店营业收入总额的3%-5%收取</span>
                </li>
                <li class="juda">
                    <span>奖励管理费</span>
                    <span>财务年度核算中，管理公司将提取合同约定GOP总额部分的10%作为奖励管理费</span>
                </li>
                <li class="juda">
                    <span>管理团队薪金<br>及福利待遇</span>
                    <span>薪资及福利依据山东文旅酒店集团统一标准执行，符合市场水平</span>
                </li>
                <li class="juda">
                    <span>系统初装及维护费</span>
                    <span>初装费优惠价：26万元，系统使用费4000元/月（按年预缴）</span>
                </li>
                <li>
                    <span>直销系统费用</span>
                    <span>7%</span>
                </li>
            </ul>
            <!-- <p class="fanpai">加盟政策（翻牌）</p>
            <ul class="fanpaijuti">
                <li>
                    <span>品牌使用期限</span>
                    <span>10年</span>
                </li>
                <li>
                    <span>品牌使用费</span>
                    <span>免收</span>
                </li>
                <li>
                    <span>品牌经营保证金</span>
                    <span>免收</span>
                </li>
                <li class="juda">
                    <span>前期技术支持服务费</span>
                    <span>如需增加现场咨询频次，每次加收5000元费用</span>
                </li>
                <li class="juda">
                    <span>基本管理费</span>
                    <span>统一按照营业总额的3%收取</span>
                </li>
                <li>
                    <span>奖励管理费</span>
                    <span>免收</span>
                </li>
                <li>
                    <span>统筹营销费</span>
                    <span>免收</span>
                </li>
                <li class="juda">
                    <span>管理团队薪金<br>及福利待遇</span>
                    <span>如需派遣管理团队：薪资及福利依据山东文旅酒店集团统一标准执行</span>
                </li>
                <li class="juda">
                    <span>系统初装及维护费</span>
                    <span>初装费优惠价20.8万元，系统使用费3000元/月（按年预缴）</span>
                </li>
                <li>
                    <span>中央预订服务费</span>
                    <span>7%</span>
                </li>
            </ul> -->
            <p class="tishi">特别提示：市场有风险，投资需谨慎</p>
            <div class="rexian">
                <p>135-1531-0058</p>
            </div>
            <div class="jiamengBtn">
                <button @click="jumpJoin">我要加盟</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
data() {
return {
swiperImg: {
url1: require('../assets/img/Yihao/one.png'),
url2: require('../assets/img/Yihao/two.png'),
url3: require('../assets/img/Yihao/three.png'),
}
}
},
mounted() {

},
methods: {
fanhui() {
this.$router.go(-1)
},
jumpJoin() {
let object = {
banner: require('../assets/img/Join/yihao.png'),
yingwen: require('../assets/img/Join/yiting1.png'),
name: 'yiting',
rexian: '135-1531-0058'
}
sessionStorage.setItem('message', JSON.stringify(object))
this.$router.push({ path: '/Join' })
}
}
}
</script>

<style lang="less" scoped>
p {
    margin: 0;
}

.fanhuiBtn {
    z-index: 1000;
    position: absolute;
    width: 48px;
    height: 48px;
    top: 20px;
    left: 20px;
}

.jiudianjieshao {
    margin: 0 30px;
    height: auto;
    padding: 0 51.5px;
    position: relative;
    margin-top: -70px;
    background-color: #ffffff;
    box-shadow: -2px -3px 16px 0px rgba(149, 127, 102, 0.33),
        3px 3px 16px 0px rgba(149, 127, 102, 0.32);
    border-radius: 10px;
    z-index: 1000;

    .logo {
        text-align: center;
        padding-top: 24px;

        img {
            width: 170px;
            height: 109px;
        }
    }

    .oneImg {
        text-align: center;
        margin-top: 24px;
        margin-bottom: 35px;

        img {
            width: 100%;
            height: 331px;
        }
    }

    .wenzijieshao {
        text-indent: 2em;
        font-family: 'pfzd';
        font-size: 28px;
        letter-spacing: 1px;
        color: #000000;
        margin-bottom: 35px;
    }

    .manxiang {
        text-align: center;
        margin-bottom: 27px;

        img {
            width: 28px;
            height: 28px;
            position: relative;
            top: -15px;
            left: 10px;
        }

        span {
            font-family: 'pfzd';
            font-size: 35px;
            color: #957f66;
            text-shadow: -1px -1px 0px #957f66, -1px -1px 0px #957f66;
        }
    }

    .photoZhanshi {
        .gaoduan {
            width: 100%;
        }

        .shishangpinzhi {
            margin-top: 19px;

            div {
                width: 50%;
                display: inline-block;

                img {
                    width: 282px;
                    height: 245px;
                }
            }

            div:first-child {
                text-align: left;
            }

            div:last-child {
                text-align: right;
            }
        }

        .shengyu {
            width: 100%;
            margin-top: 20px;
        }

        .lastImg {
            padding-bottom: 67px;
        }
    }
}

.jiamengyaoqiu {
    padding: 0 30px;

    .wuyeyaoqiu {
        font-family: 'pfzd';
        font-size: 40px;
        color: #957f66;
        text-align: center;
        margin-top: 38px;
    }

    .wuyejuti {
        width: 100%;
        height: 650px;
        margin-top: 40px;

        li {
            padding: 0 21px;
            height: 69px;
            display: flex;
            align-items: center;

            span {
                display: inline-block;
                vertical-align: middle;
                font-family: 'pfzd';
                font-size: 26px;
                letter-spacing: 0px;
                color: #3a3f49;
            }

            span:first-child {
                width: 51.5%;
            }

            span:last-child {
                width: 48.5%;
            }
        }

        li:nth-of-type(odd) {
            background-color: #f2f2f2;
        }

        li:last-child {
            height: auto;
            margin-top: 27px;

            span:last-child {
                line-height: 35px;
            }
        }
    }

    .jiamengzhengce {
        font-family: 'pfzd';
        font-size: 40px;
        line-height: 69px;
        color: #957f66;
        text-align: center;
        margin-top: 35px;
    }

    .zhengcejuti {
        width: 100%;
        height: auto;
        margin-top: 33px;

        li {
            padding: 0 21px;
            height: 69px;
            display: flex;
            align-items: center;

            span {
                display: inline-block;
                vertical-align: middle;
                font-family: 'pfzd';
                font-size: 26px;
                letter-spacing: 0px;
                color: #3a3f49;
            }

            span:first-child {
                width: 51.5%;
            }

            span:last-child {
                width: 48.5%;
            }
        }

        li:nth-of-type(odd) {
            background-color: #f2f2f2;
        }

        .juda {
            height: auto;
            padding: 25px 21px;
        }
    }

    .fanpai {
        font-family: 'pfzd';
        font-size: 40px;
        line-height: 69px;
        color: #957f66;
        text-align: center;
        margin-top: 50px;
    }

    .fanpaijuti {
        width: 100%;
        height: auto;
        margin-top: 33px;

        li {
            padding: 0 21px;
            height: 69px;
            display: flex;
            align-items: center;

            span {
                display: inline-block;
                vertical-align: middle;
                font-family: 'pfzd';
                font-size: 26px;
                letter-spacing: 0px;
                color: #3a3f49;
            }

            span:first-child {
                width: 51.5%;
            }

            span:last-child {
                width: 48.5%;
            }
        }

        li:nth-of-type(odd) {
            background-color: #f2f2f2;
        }

        .juda {
            height: auto;
            padding: 25px 21px;
        }
    }

    .tishi {
        text-align: center;
        font-family: 'pfct';
        font-size: 32px;
        line-height: 69px;
        color: #1a274b;
        margin-bottom: 59px;
        margin-top: 54px;
    }

    .rexian {
        width: 580px;
        height: 114px;
        margin: 0 auto;
        background-image: url(../assets/img/Yihao/jiameng.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        text-align: center;

        p {
            font-family: 'pfct';
            font-size: 50px;
            letter-spacing: 3px;
            color: #957f66;
            margin: 0 auto;
            margin-top: 20px;
        }
    }

    .jiamengBtn {
        text-align: center;
        margin-top: 62px;
        margin-bottom: 80px;

        button {
            width: 583px;
            height: 80px;
            background-color: #3a3f49;
            border-radius: 10px;
            color: #957f66;
            font-family: 'pfct';
            font-size: 32px;
            letter-spacing: 6px;
            border: none;
        }
    }
}
</style>
